import React from 'react';
import { useShowAppBanner } from '../../hooks/useShowAppBanner';

type Props = {
  iosUrl: string;
  androidUrl: string;
  appIconUrl?: string;
  title?: string;
  ctaLabel?: string;
};

export default function AppDownloadBannerInline({
  iosUrl,
  androidUrl,
  appIconUrl,
  title = 'Abra no app para melhor experiência',
  ctaLabel = 'Baixar',
}: Props) {
  const { show, dismiss } = useShowAppBanner();
  if (!show) return null;

  const isIOS = /iP(ad|hone|od)/i.test(navigator.userAgent);
  const storeUrl = isIOS ? iosUrl : androidUrl;

  return (
    <div className="w-full bg-gray-800">
      <div className="container mx-auto px-4 py-2.5 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          {appIconUrl && (
            <img
              src={appIconUrl}
              alt="App icon"
              className="w-10 h-10 rounded-lg flex-shrink-0"
            />
          )}
          <span className="text-xs text-white leading-tight">{title}</span>
        </div>
        <div className="flex items-center gap-2">
          <a
            href={storeUrl}
            rel="noreferrer"
            className="px-3 py-1.5 rounded-md text-sm font-semibold bg-white text-black"
          >
            {ctaLabel}
          </a>
          <button
            aria-label="Fechar banner"
            onClick={dismiss}
            className="p-1 rounded text-white hover:bg-gray-100"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}
